export const statusLookup: Array<any> = [
  { id: 0, status: 'Draft'},
  { id: 1, status: 'In Review'},
  { id: 2, status: 'Approved'},
  { id: 3, status: 'Archived'},
  { id: 4, status: 'Uploaded'},
  { id: 5, status: 'Imported'},
  { id: 6, status: 'Exported'},
  { id: 7, status: 'Revision'},
  { id: 8, status: 'Published'},
  { id: 9, status: 'Published Revision'},
  { id: 10, status: 'Unpublished'},
];
